import { render, staticRenderFns } from "./SalariesPayoutView.vue?vue&type=template&id=146e06c1"
import script from "./SalariesPayoutView.vue?vue&type=script&lang=js"
export * from "./SalariesPayoutView.vue?vue&type=script&lang=js"
import style0 from "./SalariesPayoutView.vue?vue&type=style&index=0&id=146e06c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports